import React from "react";


const Contact = () => {
  return (
    <div className="contact-page text-center">
      <section className="contact-hero">
        <h1 className="section-title">Contact DomVault</h1>
        <p className="contact-intro">
          For purchase inquiries or business collaborations, feel free to reach out via the options below.
        </p>
      </section>

      <section className="contact-info">
        <div className="contact-block">
          <h3>Email</h3>
          <p>
            <a href="mailto:info.domvault@gmail.com" className="contact-link">
              info.domvault@gmail.com
            </a>
          </p>
        </div>

      </section>

      <footer className="footer text-center">
        <p>© 2025 DomVault – The Vault for Valuable Names.</p>
      </footer>
    </div>
  );
};

export default Contact;
